import * as types from 'store/modules/hres6nu/mutation-types'
import hres6nu from 'api/hres6nu'
import swal from 'sweetalert'
import hres6nuLabels from 'assets/labels/hres6nu'
import { hres6nuColumns } from 'assets/columns/hres6nu'
import configLabel from 'src/../config/label'
import { sendApprove } from 'assets/js/sendApprove.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres6nuLabels,
    columns: hres6nuColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {}
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES6NU_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES6NU_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES6NU_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES6NU_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES6NU_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES6NU_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES6NU_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES6NU_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES6NU_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES6NU_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES6NU_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES6NU_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES6NU_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES6NU_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES6NU_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES6NU_INDEX_DISP, indexDisp)
      commit(types.SET_HRES6NU_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES6NU_COLUMNS_LABELS] ({ commit }) {
      hres6nu.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6NU_COLUMNS, data.labels)
          commit(types.SET_HRES6NU_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6NU_INDEX] ({ commit }, searchParams) {
      hres6nu.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6NU_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6NU_DETAIL] ({ commit }, searchParams) {
      hres6nu.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6NU_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES6NU_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres6nu.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES6NU_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6nu/index.js